// frontend/src/components/member-dashboard/components/MembershipSidebar.js
//
// Sidebar "Your credits": the same list as the dashboard card
// (MemberCreditsCard, data from GET /api/profile/credit-summary with the
// booking rules). Add-ons have their own sidebar card (MemberAddOns).
// Shows nothing while the member has no credits and nothing expired
// recently, as before.
import React from "react";
import PropTypes from "prop-types";
import { FaIdCard } from "react-icons/fa";
import MemberCreditsCard from "./MemberCreditsCard";
import { useMemberCreditSummary } from "../../../hooks/useMemberCreditSummary";
import "./MembershipSidebar.css";

const MembershipSidebar = ({ profile }) => {
  const { summary, loading, error } = useMemberCreditSummary(profile);
  if (!profile) return null;
  const hasContent =
    (summary?.rows?.length || 0) > 0 || (summary?.recentlyExpired?.length || 0) > 0;
  if (!loading && !error && !hasContent) return null;

  return (
    <div className="membership-sidebar">
      <h4 className="sidebar-section-title">
        <FaIdCard className="sidebar-icon" />
        Your credits
      </h4>
      <MemberCreditsCard summary={summary} loading={loading} error={error} variant="sidebar" />
    </div>
  );
};

MembershipSidebar.propTypes = {
  profile: PropTypes.object,
};

export default MembershipSidebar;
